import { Box, CircularProgress } from "@mui/material";
import AppLayout from "components/AppLayout";
import ImageAnnouncementModal from "components/common/ImageAnnouncementModal";
import { StripePaymentMethodProvider } from "hooks/paymentMethods/useStripePaymentMethod";
import { AuthProvider } from "hooks/useAuth";
import { CurrentUserProvider } from "hooks/useCurrentUserPermission";
import { useGlobalLoader } from "hooks/useGlobalLoader";
import { OrganizationConfigurationProvider } from "hooks/useOrganizationConfiguration";
import { Outlet } from "react-router-dom";
import logo from "assets/images/logo.png";

function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <OrganizationConfigurationProvider>
      <AuthProvider>
        <CurrentUserProvider>
          <StripePaymentMethodProvider>{children}</StripePaymentMethodProvider>
          <ImageAnnouncementModal
            imageUrl="/announcements/end_of_year_giving_banner.png"
            featureFlagName="end_of_year_giving_announcement_enabled"
            redirectTo="/donations-and-earnings/donations"
            timesToDisappear={3}
          />
        </CurrentUserProvider>
      </AuthProvider>
    </OrganizationConfigurationProvider>
  );
}

function LoadingElement() {
  return (
    <Box width="100%" height="100vh" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
      <img src={logo} width="120px" alt="Logo" />
      <CircularProgress color="primaryPro" sx={{ marginTop: 3 }} />
    </Box>
  );
}

export default function App() {
  const { loading } = useGlobalLoader();
  return (
    <AppProviders>
      {loading ? (
        <LoadingElement />
      ) : (
        <AppLayout>
          <Outlet />
        </AppLayout>
      )}
    </AppProviders>
  );
}
